import React from 'react'
import { GridApi } from '@ag-grid-community/core'
import { PlusOutlined } from '@ant-design/icons'
import { Typography } from '@sureco/design-system'

interface BulkUpdateTableCustomStatusBarProps {
  api: GridApi
  onAddRow: () => void
  disableAddRow?: boolean
}

export const BulkUpdateTableCustomStatusBar: React.FC<
  BulkUpdateTableCustomStatusBarProps
> = ({ api, onAddRow, disableAddRow }) => {
  const selectedCount = api?.getSelectedRows()?.length || 0

  return (
    <div
      style={{
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #f0f0f0',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Typography size={14} color="secondary">
        {selectedCount > 0 ? `${selectedCount} selected` : ''}
      </Typography>
      {!disableAddRow && (
        <div
          onClick={onAddRow}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'pointer',
            color: '#1890ff',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#40a9ff'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#1890ff'
          }}
        >
          <PlusOutlined style={{ fontSize: '14px' }} />
          <Typography size={14}>Add Row</Typography>
        </div>
      )}
    </div>
  )
}
